var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from "react";

function SvgShBirthdayCakeSolid(props) {
  return React.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 13.537 13.06"
    }, props),
    React.createElement("path", { d: "M13.537 9.8c-.847 0-.945-.816-2.251-.816S9.871 9.8 9.027 9.8s-.95-.816-2.259-.816-1.426.816-2.251.816c-.851 0-.943-.816-2.259-.816S.849 9.8 0 9.8V7.754A1.352 1.352 0 011.45 6.53h.483V2.857h1.935V6.53H5.8V2.857h1.935V6.53h1.934V2.857H11.6V6.53h.483a1.352 1.352 0 011.45 1.224zm0 3.265H0v-2.454c1.31 0 1.413-.816 2.259-.816s.944.816 2.259.816c1.295 0 1.427-.816 2.251-.816.851 0 .943.816 2.259.816S10.44 9.8 11.286 9.8s.944.816 2.251.816zM2.9 2.449a.9.9 0 01-.967-.816C1.934.842 2.9 1.046 2.9 0c.363 0 .967.752.967 1.428A.929.929 0 012.9 2.449zm3.868 0a.9.9 0 01-.968-.816c0-.791.967-.587.967-1.633.363 0 .967.752.967 1.428a.929.929 0 01-.966 1.021zm3.868 0a.9.9 0 01-.967-.816c0-.791.967-.587.967-1.633.364 0 .964.752.964 1.428a.929.929 0 01-.964 1.021z" })
  );
}

export default SvgShBirthdayCakeSolid;